import { useVideo } from '@hooks/useVideo'
import { desktopCSS, tabletCSS } from '@measures/responsive'
import { printCSS } from '@utils/style'
import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

const StyledHeaderWrapper = styled.div<{ isVideoOverlayOpen: boolean }>`
  ${({ isVideoOverlayOpen }) => css`
    width: 100%;
    box-sizing: border-box;
    position: sticky;
    ${printCSS(css`
      position: unset;
      margin-bottom: 8px;
    `)}
    /* Header should not be hidden by ads */
    /* the ads' highest z-index we know is 9400 */
    z-index: 10000;
    top: 0;
    ${desktopCSS(css`
      padding: 0 20px;
    `)}

    ${tabletCSS(css`
      padding: 0 52px;
    `)}

    ${isVideoOverlayOpen &&
    css`
      visibility: hidden;
    `}
  `}
`

const HeaderWrapper: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const { isOverlay } = useVideo()

  return (
    <StyledHeaderWrapper isVideoOverlayOpen={!!isOverlay}>
      {children}
    </StyledHeaderWrapper>
  )
}

export default HeaderWrapper
